export default function useQueriesAreLoading(queries) {
  return queries.some((query) => query.isLoading);
}
